module.exports = __webpack_public_path__ + "img/add_circle_outline.e2028a75.svg";